import React from 'react';

import {CreateOrEditGuideType, GuideTypeBody, ReferenceListBodySkeleton} from "@/components";
import {useLanguage} from "@/contexts/languageContext";
import {ReferenceList} from "@/routes/list/ReferenceList";

export const GuideTypeList = () => {
    const {language, t} = useLanguage();

    return <ReferenceList
        entity="guide_type"
        Body={GuideTypeBody}
        BodySkeleton={ReferenceListBodySkeleton}
        EditBody={CreateOrEditGuideType}
        description={t('guides.guideTypesDescription')}
        sorts={[
            ['sortOrder', 'asc', t('sentences.sortByField', {field: t('fields.order'), order: t('orders.asc')})],
            ['sortOrder', 'desc', t('sentences.sortByField', {field: t('fields.order'), order: t('orders.desc')})],
        ]}
        getDeletionText={(e) => `"${e?.[`${language}Title`] ?? ''}"`.slice(0, 200)}
    />;
};

export default GuideTypeList;
